import { formatPhone } from "presentation/common";
import dayjs from "dayjs";
import { get, omit } from "lodash";

export const getStep1FormData = (data) => {
  const formData = new FormData();

  const groupFileByDocType =
    data.files?.reduce((acc, doc) => {
      if (!acc[doc.type]) {
        acc[doc.type] = [];
      }

      acc[doc.type].push(doc.file);

      return acc;
    }, {}) ?? {};

  if (groupFileByDocType["Factura"]) {
    formData.append("factura", groupFileByDocType["Factura"][0]);
  }

  if (groupFileByDocType["DS55"]) {
    formData.append("ds55", groupFileByDocType["DS55"][0]);
  }

  groupFileByDocType?.["Nota de Crédito"]?.forEach((file) => {
    formData.append("list_nota_credito", file);
  });

  formData.append("email", data.email);
  formData.append("rut", data.rut);
  formData.append("name", data.name);
  formData.append("father_lastname", data.firstName);
  formData.append("mother_lastname", data.lastName);
  formData.append("phone", formatPhone(data.phone, data.countryCode));

  formData.append("vehicle_type", data.vehicleType.replace(/\s/g, "_"));
  formData.append("emisor_factura", data.billIssuerSelected?.unique_id);
  formData.append("net_amount", data.netAmount);
  formData.append("fuel_type", data.fuel_type);
  formData.append("anual", data.anual);
  formData.append("id_solicitud", data.requestId || "");
  formData.append("recaptcha", data.recaptcha);
  formData.append(
    "fecha_emision",
    dayjs(data.dateOfIssue).format("YYYY-MM-DD")
  );

  // it means is not the owner
  getOwnerInfo(data).forEach((value, key) => {
    formData.append(key, value);
  });

  return formData;
};

export const getStep2FormData = (data) => {
  const formData = getStep1FormData(data);
  const dispatchData = data.dispatchData;

  formData.append("despacho_region", dispatchData.regionSelected.label);
  formData.append("despacho_comuna", dispatchData.comunaSelected.label);
  formData.append("despacho_region_uuid", dispatchData.region);
  formData.append("despacho_comuna_uuid", dispatchData.comuna);
  formData.append("despacho_calle", dispatchData.street);
  formData.append("despacho_numero", dispatchData.number);
  formData.append("despacho_complemento", dispatchData.complement || "");

  return formData;
};

const getOwnerInfo = (data) => {
  const formData = new FormData();

  if (data.isOwner === "0") {
    if (data.personType === "JURÍDICA") {
      const { countryCode, email, phone, rut, businessType, economicActivity } =
        data.ownerBillInfo;
      formData.append("owner_rut_billing", rut);
      formData.append("owner_economic_activity", economicActivity || "");
      formData.append("owner_social_reason", businessType);

      formData.append("owner_email", email);
      formData.append("owner_phone", formatPhone(phone, countryCode));
      return formData;
    }

    const { countryCode, rut, name, firstName, lastName, email, phone } =
      data.personInfo;
    formData.append("owner_email", email);
    formData.append("owner_rut", rut);
    formData.append("owner_name", name);
    formData.append("owner_father_lastname", firstName);
    formData.append("owner_mother_lastname", lastName || "");
    formData.append("owner_phone", formatPhone(phone, countryCode));
  }

  return formData;
};

export const getDocsFromServer = (response) => {
  if (!response?.data) return { ...response, data: [] };

  return {
    ...response,
    data: get(response.data, "response.search.hits.hits").map((doc) => {
      const body = get(doc, "_source");
      return omit(body, [
        "type",
        "updated_at",
        "tenant",
        "signed",
        "secondary_parent",
        "read_privileged",
        "required_signature",
        "nodetype",
        "alter_privileged",
      ]);
    }),
  };
};

const status = {
  PENDIENTE: "Pendiente",
  EN_PROCESO: "En Proceso",
  DESPACHADO: "Despachado",
  TRAMITE_PENDIENTE: "Trámite Pendiente",
  DEVUELTO: "Devuelto",
  CANCELADO: "Cancelado",
};
export const getMyDocumentsFromServer = (response) => {
  if (!response?.data) return { ...response, data: [] };

  return {
    ...response,
    data: get(response.data, "response.search.hits.hits")
      .filter((doc) => doc._source.request_status && doc._source.tipo_vehiculo)
      .map((doc) => {
        const body = get(doc, "_source");

        return {
          ...omit(body, [
            "type",
            "updated_at",
            "tenant",
            "signed",
            "secondary_parent",
            "read_privileged",
            "required_signature",
            "nodetype",
            "alter_privileged",
          ]),
          statusName: status[body.request_status] || "",
          createdAt: dayjs(body.inserted_at).format("DD/MM/YYYY"),
        };
      }),
  };
};
